var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center mt-2"},[_c('div',{staticClass:"font-weight-bold grey--text text--darken-1 mt-2"},[_vm._v(" Copyright "),_c('a',{attrs:{"href":_vm.$config.website,"target":"_blank"}},[_vm._v(_vm._s(_vm.$config.companyName))]),_vm._v(" "+_vm._s(_vm.MIX_formatDateTimeNow('YYYY'))+" ")]),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }